/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RewardType } from './RewardType';
import {
    RewardTypeFromJSON,
    RewardTypeFromJSONTyped,
    RewardTypeToJSON,
    RewardTypeToJSONTyped,
} from './RewardType';

/**
 * 
 * @export
 * @interface ClaimedRewardDetail
 */
export interface ClaimedRewardDetail {
    /**
     * 
     * @type {RewardType}
     * @memberof ClaimedRewardDetail
     */
    type: RewardType;
    /**
     * 
     * @type {string}
     * @memberof ClaimedRewardDetail
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimedRewardDetail
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimedRewardDetail
     */
    couponCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimedRewardDetail
     */
    targetUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimedRewardDetail
     */
    qrImageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimedRewardDetail
     */
    claimFormUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimedRewardDetail
     */
    giftCardBrandName?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimedRewardDetail
     */
    giftCardAmount?: number;
}



/**
 * Check if a given object implements the ClaimedRewardDetail interface.
 */
export function instanceOfClaimedRewardDetail(value: object): value is ClaimedRewardDetail {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ClaimedRewardDetailFromJSON(json: any): ClaimedRewardDetail {
    return ClaimedRewardDetailFromJSONTyped(json, false);
}

export function ClaimedRewardDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimedRewardDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'type': RewardTypeFromJSON(json['type']),
        'name': json['name'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'couponCode': json['couponCode'] == null ? undefined : json['couponCode'],
        'targetUrl': json['targetUrl'] == null ? undefined : json['targetUrl'],
        'qrImageUrl': json['qrImageUrl'] == null ? undefined : json['qrImageUrl'],
        'claimFormUrl': json['claimFormUrl'] == null ? undefined : json['claimFormUrl'],
        'giftCardBrandName': json['giftCardBrandName'] == null ? undefined : json['giftCardBrandName'],
        'giftCardAmount': json['giftCardAmount'] == null ? undefined : json['giftCardAmount'],
    };
}

export function ClaimedRewardDetailToJSON(json: any): ClaimedRewardDetail {
    return ClaimedRewardDetailToJSONTyped(json, false);
}

export function ClaimedRewardDetailToJSONTyped(value?: ClaimedRewardDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': RewardTypeToJSON(value['type']),
        'name': value['name'],
        'amount': value['amount'],
        'couponCode': value['couponCode'],
        'targetUrl': value['targetUrl'],
        'qrImageUrl': value['qrImageUrl'],
        'claimFormUrl': value['claimFormUrl'],
        'giftCardBrandName': value['giftCardBrandName'],
        'giftCardAmount': value['giftCardAmount'],
    };
}

